const NotificationPopUp = () => {
  function showNotification() {
    const title = "New Message from Tickets.lk";
    const options = {
      body: "Welcome aboard!",
      icon: "public/Site_logo.svg",
    };

    const n = new Notification(title, options);
  }

  if (Notification.permission === "granted") {
    showNotification();
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        showNotification();
      }
    });
  }

  return <></>;
};

export default NotificationPopUp;
